// import Home from "../pages/Home.vue";
import AjoutMessage from "../pages/message/Add.vue";
import DetailsMessage from "../pages/message/Show.vue";
import MessagesPage from "../pages/message/Index.vue";
import detailMsg from "../pages/message/detail.vue";
//import DevoirList  from '../pages/DevoirMaison.vue';
import ClassList from "../pages/classe/Index.vue";

import DevoirList from "../pages/homeWorks/Index.vue";
//import ClassList from "../pages/ClassesList.vue"
import Login from "../pages/Login.vue";
import Password from "../pages/auth/resetPassword.vue";
import ResetPassword from "../pages/auth/forgotPassword.vue";
//homeWork
import AjoutDm from "../pages/homeWorks/Add.vue";
import EditDm from "../pages/homeWorks/Edit.vue";
import DetailsDM from "../pages/homeWorks/Show.vue";
import MatiereList from "../pages/MatiereList.vue";
import AjoutClasse from "../pages/classe/Add.vue";
import EditClasse from "../pages/classe/Edit.vue";
import DetailsClasse from "../pages/classe/DetailsClasse";
import AjoutTuteur from "../pages/AjoutTuteur.vue";
import AddEleve from "../pages/eleve/Add.vue";
// import AddEleveTest from "../pages/eleve/AddEdit.vue";

import EditEleve from "../pages/eleve/Edit.vue";
import StudentsList from "../pages/eleve/Index.vue";
import DetailStudent from "../pages/eleve/Show.vue";
import ParentList from "../pages/parent/Index.vue";
import ParentShow from "../pages/parent/Show.vue";
import TeachersList from "../pages/teacher/Index.vue";
import DetailTeacher from "../pages/teacher/DetailTeacher.vue";
import EditTeacher from "../pages/teacher/Edit.vue";
import AddTeacher from "../pages/teacher/Add.vue";
import ErrorPage404 from "../pages/404.vue";
import ErrorPage403 from "../pages/403.vue";
//superAdmin
import EcoleList from "../pages/superAdmin/ecole/Index.vue";
import examperiodList from "../pages/superAdmin/periodexam/Index.vue";
import addPeriodExam from "../pages/superAdmin/periodexam/addPeriodExam.vue";
import AddEcole from "../pages/superAdmin/ecole/Add.vue";
import DetailsSchool from "../pages/superAdmin/ecole/Detail.vue";
import EditEcole from "../pages/superAdmin/ecole/Edit.vue";
//SERVICES
import ServiceList from "../pages/services/Index.vue";
import AddService from "../pages/services/Add.vue";
import EditPrix from "../pages/services/EditPrix.vue";
import EditService from "../pages/services/Edit.vue";
import DetailsService from "../pages/services/DetailsService.vue";
import AddPrix from "../pages/services/AddPrix.vue";
//PAIEMENT
import PaymentList from "../pages/payments/Index.vue";
import ParamService from "../pages/payments/ParametrageServices.vue";
import AddPayment from "../pages/payments/Add.vue";
import DetailsPayment from "../pages/payments/DetailsPayment.vue";
import {createRouter, createWebHistory} from "vue-router";
//ACCUEIL
import Dashboard from "../pages/Dashboard.vue";
//CALENDAR
import EventsList from "../pages/EventsList.vue";
//ACTUALITES
import ArticlesList from "../pages/article/Index.vue";
import DetailsArticle from "../pages/article/DetailsArticle";
//CATEGORIES
import CategoriesList from "../pages/categorie/Index.vue";
//CANTINE
import CantineList from "../pages/cantine/Index.vue";
import editCantine from "../pages/cantine/Edit.vue";
import addCantine from "../pages/cantine/Add.vue";
import EditUser from "../pages/user/EditUser.vue";
import Privacy from "../pages/Privacy.vue";
import addNote from "../pages/notes/add.vue";
import listNote from "../pages/notes/index.vue";
import Detailnote from "../pages/notes/detail.vue";
import noteSubjectDetail from "../pages/notes/noteSubjectDetail.vue";
import BulletinNotes from "../pages/bulletin/bulletinNotes.vue";
import DomainList from "../pages/bulletin/domainList.vue";
import NotesExamen from "../pages/bulletin/notesExamen.vue";
import bulletinsList from "../pages/bulletin/bulletinList.vue";

//REGISTER
import ShowRegisterPresenc from "../pages/registrePresence/show.vue";
import AddRegister from "../pages/registrePresence/AddRegister.vue";

//examSchedule

import examSchedule from "../pages/examSchedule/index.vue";
import examScheduleAdd from "../pages/examSchedule/addEdit.vue";
//RDV
import listeRdv from "../pages/rdv/Index.vue";
import addRdv from "../pages/rdv/Add.vue";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/error-404",
  },
  {
    path: "/error-404",
    name: "ErrorPage404",
    component: ErrorPage404,
    meta: {
      layout: "ErrorLayout",
    },
  },
  {
    path: "/error-403",
    name: "ErrorPage403",
    component: ErrorPage403,
    meta: {
      layout: "ErrorLayout",
    },
  },
  {
    path: "/",
    name: "dashboard",
    component: Dashboard,
    meta: {
      layout: "default",
    },
  },

  {
    path: "/admin/edit/:id",
    name: "EditUser",
    component: EditUser,
  },
  {
    path: "/devoirs",
    name: "home_works",
    component: DevoirList,
    meta: {
      parent: "home_works",
    },
  },
  {
    path: "/devoirs/:id",
    name: "DetailsDM",
    component: DetailsDM,
  },
  {
    path: "/teachers",
    name: "teacher_list",
    component: TeachersList,
    meta: {
      parent: "teacher_list",
    },
  },
  {
    path: "/addteachers",
    name: "add_teacher",
    component: AddTeacher,
  },
  {
    path: "/teachers/teacher/:id",
    name: "DetailTeacher",
    component: DetailTeacher,
  },
  {
    path: "/teachers/edit/:id",
    name: "EditTeacher",
    component: EditTeacher,
    meta: {
      parent: "teachers_list",
    },
  },
  {
    path: "/parents",
    name: "parent_list",
    component: ParentList,
    meta: {
      layout: "default",
    },
  },
  {
    path: "/parents/:id",
    name: "show-parent",
    component: ParentShow,
    meta: {
      layout: "default",
    },
  },
  {
    path: "/addschool",
    name: "add_school",
    component: AddEcole,
  },
  {
    path: "/ecole-detail/:id",
    name: "school_detail",
    component: DetailsSchool,
  },
  {
    path: "/ecole/edit/:id",
    name: "EditSchool",
    component: EditEcole,
    meta: {
      parent: "parent_list",
    },
  },
  {
    path: "/listecole",
    name: "school_list",
    component: EcoleList,
  },
  {
    path: "/listperiodexam",
    name: "periodexam_list",
    component: examperiodList,
  },
  {
    path: "/priodexam/add",
    name: "addPeriodExam",
    component: addPeriodExam,
    meta: {
      parent: "periodexam_list",
    },
  },
  {
    path: "/devoirsmaison/add",
    name: "AjoutDm",
    component: AjoutDm,
    meta: {
      parent: "home_works",
    },
  },
  {
    path: "/devoirsmaison/edit/:id",
    name: "EditDm",
    component: EditDm,
    meta: {
      parent: "home_works",
    },
  },
  {
    path: "/eleves",
    name: "student_list",
    component: StudentsList,
  },
  {
    path: "/eleves/add",
    name: "AddStudent",
    component: AddEleve,
    meta: {
      parent: "student_list",
    },
  },
  // {
  //   path: "/eleves/addtest",
  //   name: "AddStudentTest",
  //   component: AddEleveTest,
  //   meta: {
  //     parent: "student_list",
  //   },
  // },
  {
    path: "/eleves/eleve/:id",
    name: "DetailStudent",
    component: DetailStudent,
  },
  {
    path: "/eleves/edit/:id",
    name: "EditStudent",
    component: EditEleve,
    meta: {
      parent: "student_list",
    },
  },
  {
    path: "/classes",
    name: "ClasseList",
    component: ClassList,
  },
  {
    path: "/classes/add",
    name: "AjoutClasse",
    component: AjoutClasse,
    meta: {
      parent: "ClasseList",
    },
  },
  {
    path: "/classes/classe/:id",
    name: "DetailsClasse",
    component: DetailsClasse,
    meta: {
      parent: "ClasseList",
    },
  },
  {
    path: "/classes/edit/:id",
    name: "EditClasse",
    component: EditClasse,
    meta: {
      parent: "ClasseList",
    },
  },
  {
    path: "/ajoutTuteur",
    name: "AjoutTuteur",
    component: AjoutTuteur,
  },
  {
    path: "/courses",
    name: "MatiereList",
    component: MatiereList,
    //  meta: {
    //    layout: 'default'
    //  }
  },
  {
    path: "/evenements",
    name: "eventsList",
    component: EventsList,
  },
  {
    path: "/cantines",
    name: "cantineList",
    component: CantineList,
  },
  {
    path: "/cantines/edit",
    name: "editCantine",
    component: editCantine,
  },
  {
    path: "/cantines/add",
    name: "addCantine",
    component: addCantine,
  },

  {
    path: "/articles",
    name: "articleList",
    component: ArticlesList,
  },
  {
    path: "/articles/article/:id",
    name: "DetailsArticle",
    component: DetailsArticle,
    meta: {
      parent: "ArticlesList",
    },
  },
  {
    path: "/categories",
    name: "categorieList",
    component: CategoriesList,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      layout: "AuthLayout",
    },
  },
  {
    path: "/password",
    name: "password",
    component: Password,
    meta: {
      layout: "AuthLayout",
    },
  },
  {
    path: "/password/reset",
    name: "confirmationPassword",
    component: ResetPassword,
    meta: {
      layout: "AuthLayout",
    },
  },

  {
    path: "/messages/ajoutmessage",
    name: "AjoutMessage",
    component: AjoutMessage,
    meta: {
      parent: "Message",
    },
  },
  {
    path: "/messages/message/:id",
    name: "DetailsMessage",
    component: DetailsMessage,
    meta: {
      parent: "Message",
    },
  },
  {
    path: "/messages",
    name: "Message",
    component: MessagesPage,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.

    // meta: {
    //   layout: 'default'
    // }
  },
  {
    path: "/msg/detail/:id",
    name: "detailMsg",
    component: detailMsg,
    meta: {
      parent: "Message",
    },
  },

  {
    path: "/services",
    name: "ServiceList",
    component: ServiceList,
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy,
    meta: {
      layout: "AuthLayout",
    },
  },
  {
    path: "/services/Add",
    name: "AddService",
    component: AddService,
  },
  {
    path: "/services/editPrix/:id",
    name: "EditPrix",
    component: EditPrix,
  },
  {
    path: "/services/edit/:id",
    name: "EditService",
    component: EditService,
  },
  {
    path: "/services/service/:id",
    name: "DetailsService",
    component: DetailsService,
    meta: {
      parent: "ListService",
    },
  },
  {
    path: "/services/AddPrix/:id",
    name: "AddPrix",
    component: AddPrix,
  },
  {
    path: "/payments",
    name: "PaymentList",
    component: PaymentList,
  },
  {
    path: "/parametrageServices",
    name: "ParamService",
    component: ParamService,
  },
  {
    path: "/payments/Add/:id",
    name: "AddPayment",
    component: AddPayment,
  },
  {
    path: "/payments/payment/:id",
    name: "DetailsPayment",
    component: DetailsPayment,
    meta: {
      parent: "ListPayment",
    },
  },
  {
    path: "/notes",
    name: "ListNotes",
    component: listNote,
    meta: {
      parent: "ListNotes",
    },
  },
  {
    path: "/notes/add",
    name: "addNote",
    component: addNote,
    meta: {
      parent: "ListNotes",
    },
  },

  {
    path: "/notes/edit/:classid/:courseid/:periodid/:examtypeid",
    name: "editNote",
    component: addNote,
    meta: {
      parent: "ListNotes",
    },
  },
  {
    path: "/notes/:id",
    name: "Detailnote",
    component: Detailnote,
    meta: {
      parent: "ListNotes",
    },
  },
  {
    path: "/notesDetail/:classid/:courseid/:coursePeriode",
    name: "DetailnoteSubject",
    component: noteSubjectDetail,
    meta: {
      parent: "ListNotes",
      isCreated: false,
    },
  },
  {
    path: "/bulletin-notes",
    name: "BulletinNotes",
    component: BulletinNotes,
    meta: {
      parent: "ListNotes",
    },
  },
  {
    path: "/domain-list/:id",
    name: "DomainList",
    component: DomainList,
    meta: {
      parent: "ListNotes",
    },
  },
  {
    path: "/notes-examen/:id",
    name: "NotesExamen",
    component: NotesExamen,
    meta: {
      parent: "ListNotes",
    },
  },
  {
    path: "/notes-examen/edit/:id",
    name: "EditNotesExamen",
    component: NotesExamen,
    meta: {
      parent: "ListNotes",
    },
  },
  {
    path: "/bulletin-list/:id",
    name: "bulletinsList",
    component: bulletinsList,
    meta: {
      parent: "ListNotes",
    },
  },
  {
    path: "/exam/schedule",
    name: "examSchedule",
    component: examSchedule,
  },
  {
    path: "/exam/schedule/add",
    name: "examScheduleAdd",
    component: examScheduleAdd,
  },
  {
    path: "/exam/schedule/edit/:id",
    name: "examScheduleEdit",
    component: examScheduleAdd,
  },
  {
    path: "/register",
    name: "ShowRegisterPresenc",
    component: ShowRegisterPresenc,
  },
  {
    path: "/register",
    name: "ShowRegisterPresenc",
    component: ShowRegisterPresenc,
  },
  {
    path: "/register/add",
    name: "AddRegister",
    component: AddRegister,
  },

  {
    path: "/rdv/list",
    name: "listeRdv",
    component: listeRdv,
  },
  {
    path: "/rdv/add",
    name: "addRdv",
    component: addRdv,
  },
];

const router = createRouter({
  linkActiveClass: "active",
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    const scroll = {};
    if (to.meta.toTop) scroll.top = 0;
    if (to.meta.smoothScroll) scroll.behavior = "smooth";
    return scroll;
  },
});

router.beforeEach((to, from, next) => {
  /*  if (to.path === '/bar') {
         next('/');

         return;
     } */
  const publicPages = ["/login", "/privacy", "/password", "/password/reset"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("user");

  const adminSchool = ["/eleves", "/", "/classes", "/courses"];
  const admin = ["/addschool"];
  const authadminSchool = adminSchool.includes(to.path);

  const authadmin = admin.includes(to.path);
  let existDev = false;
  let existMess = false;
  let existPay = false;
  let existAct = false;
  let existEven = false;
  if (loggedIn != null) {
    JSON.parse(loggedIn)?.role?.map((res) => {
      if (res.name === "admin" && to.path === "/") {
        next("/listecole");
      }
    });
  }
  if (loggedIn != null) {
    JSON.parse(loggedIn)?.role?.map((res) => {
      if (res.name === "admin_school" && to.path === "/listecole") {
        next("error-403");
      }
    });
  }

  if (authadminSchool) {
    if (loggedIn != null) {
      JSON.parse(loggedIn).role?.map((res) => {
        if (res.name === "admin_school" || res.name === "parent") {
          next(true);
        } else {
          next(false);
        }
      });
    }
  } else if (authadmin) {
    if (loggedIn != null) {
      JSON.parse(loggedIn).role?.map((res) => {
        if (res.name === "admin") {
          next(true);
        } else {
          next(false);
        }
      });
    }
  }

  // trying to access a restricted page + not logged in
  // redirect to login page

  if (authRequired && !loggedIn) {
    next("/login");
  } else {
    next();
  }
});

export {router};
